import React from "react";
import { Modal, Button, Form, Spinner, Row, Col } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSave, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
const FormData = ({
    show,
    handleClose,
    formAttribute,
    handleChange,
    handleChangeFormArray,
    handleSubmit,
    isLoading,
    validate,
    addRoutePoint,
    removeRoutePoint
}) => {
    const { title, data } = formAttribute;
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">{title}</Modal.Title>
                <FalconCloseButton onClick={handleClose} variant="white"/>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validate} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formGroupKode">
                        <Form.Label>Kode</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={data?.vckode} 
                            onChange={(event) => handleChange(event)} 
                            name="vckode" 
                            placeholder="Kode"
                            readOnly
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Kode tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupNama">
                        <Form.Label>Nama</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcnama}
                            onChange={(event) => handleChange(event)}
                            name="vcnama"
                            placeholder="Nama" 
                            readOnly
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nama tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    {
                        data?.titik_rute_map ? data?.titik_rute_map.map((value, index) => {
                            return (
                                <Row className="mb-3 g-3" key={index}>
                                    <Form.Group as={Col} controlId="decLatitude">
                                        <Form.Label>Koordinat Latitude</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            placeholder="Koordinat Latitude" 
                                            name="declattitude" 
                                            value={value.declattitude}
                                            onChange={(e) => handleChangeFormArray(e, index, 'titik_rute_map')} />
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="decLongitude">
                                        <Form.Label>Koordinat Longitude</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            placeholder="Koordinat Longitude" 
                                            name="declongitude" 
                                            value={value.declongitude}
                                            onChange={(e) => handleChangeFormArray(e, index, 'titik_rute_map')} />
                                    </Form.Group>

                                    <Col xs={1}>
                                        <Form.Group controlId="decLongitude">
                                            <Form.Label>&nbsp;</Form.Label>
                                            <Button variant="danger" onClick={() => removeRoutePoint(index)}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </Button>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )
                        }) : ''
                    }
                    
                    <Row className="mb-3 g-3 justify-content-md-center">
                        <Col lg={4}>
                            <Button onClick={addRoutePoint}>
                                <FontAwesomeIcon icon={faPlus} /> Tambah Titik Rute
                            </Button>
                        </Col>
                    </Row>

                    
                    <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                    </Button>
                    <Button disabled={isLoading} type="submit" className="float-end">
                        {isLoading ? (<>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Loading...
                        </>
                        ) : (<>
                            <FontAwesomeIcon icon={faSave} className="me-2" />
                            Simpan
                        </>) }
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

FormData.propTypes = {}

export default FormData;